import moment from "moment";
export function formatTimeAgo(timestamp) {
  return moment(timestamp * 1000).fromNow();
}